/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Renders_RenderingInputs */

const en_directory_ai_tools_renders_rendering = /** @type {(inputs: Directory_Ai_Tools_Renders_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering… usually 2–5 minutes`)
};

const zh_directory_ai_tools_renders_rendering = /** @type {(inputs: Directory_Ai_Tools_Renders_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成中…通常需要 2–5 分钟`)
};

/**
* | output |
* | --- |
* | "Rendering… usually 2–5 minutes" |
*
* @param {Directory_Ai_Tools_Renders_RenderingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_renders_rendering = /** @type {((inputs?: Directory_Ai_Tools_Renders_RenderingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Renders_RenderingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_renders_rendering(inputs)
	return zh_directory_ai_tools_renders_rendering(inputs)
});
export { directory_ai_tools_renders_rendering as "directory.ai_tools.renders.rendering" }